class PdpDetailsTabs {
  constructor() {
    this.section = document.querySelector('.pdp-details-tabs-section');

    if (!this.section) return;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initialize());
    } else {
      this.initialize();
    }
  }

  initialize() {
    this.isMobile = () => window.innerWidth < 768;

    // Desktop: tab switching via tabs-nav buttons
    this.buttons = this.section.querySelectorAll('.tab-button');
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].addEventListener('click', () => {
        this.activateTab(this.buttons[i].dataset.tab);
      });
    }

    // Mobile: accordion via mobile headers
    this.accordionHeaders = this.section.querySelectorAll('.tab-mobile-header');
    for (let j = 0; j < this.accordionHeaders.length; j++) {
      this.accordionHeaders[j].addEventListener('click', () => {
        this.toggleAccordion(this.accordionHeaders[j]);
      });
    }
  }

  activateTab(tabId) {
    if (this.isMobile()) return; // tabs-nav is hidden on mobile, ignore

    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].classList.remove('active');
    }

    const contents = this.section.querySelectorAll('[data-tab-content]');
    for (let j = 0; j < contents.length; j++) {
      contents[j].classList.remove('active');
    }

    const activeBtn = this.section.querySelector('[data-tab="' + tabId + '"]');
    const activeContent = this.section.querySelector('[data-tab-content="' + tabId + '"]');

    if (activeBtn) activeBtn.classList.add('active');
    if (activeContent) {
      activeContent.classList.add('active');

      const inner = activeContent.querySelector('.tab-inner');
      if (inner) {
        inner.style.animation = 'none';
        void inner.offsetHeight;
        inner.style.animation = '';
      }
    }
  }

  toggleAccordion(header) {
    const content = header.closest('[data-tab-content]');
    if (!content) return;

    const isActive = content.classList.contains('active');

    // Close all accordion items
    const allContents = this.section.querySelectorAll('[data-tab-content]');
    for (let i = 0; i < allContents.length; i++) {
      allContents[i].classList.remove('active');
    }

    // If it wasn't active, open it (toggle behavior)
    if (!isActive) {
      content.classList.add('active');
    }
  }
}

new PdpDetailsTabs();
